<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { computed, ref, getCurrentInstance } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { pageTitleForRoute } from '@/layout/admin/menu.js';

import AdminNotificationsDropdown from './AdminNotificationsDropdown.vue';
import AdminProfileDropdown from './AdminProfileDropdown.vue';
import SelectLanguage from '@/views/linkarme/components/SelectLanguage.vue';
import RightMenu from '@/layout/main/RightMenu.vue';
import SelectCurrency from '../../views/linkarme/components/SelectCurrency.vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;
const page = usePage();

const search = ref('');
const rightMenuRef = ref(null);

const pageTitle = computed(() => {
    // page.url keeps this reactive across Inertia visits (route() alone is not reactive)
    void page.url;
    const title = pageTitleForRoute(route().current());
    return title ? $t(title) : 'Linkarme';
});

const { calculatedMenuMode, toggleMenuState } = useLayout();
const rightMenuOpen = ref(false);

const toggleRightMenu = () => {
    rightMenuRef.value?.toggle();
};
</script>

<template>
    <header :class="calculatedMenuMode === 'overlay' || calculatedMenuMode === 'static' ? 'pl-4' : 'pl-6'" class="md:max-h-16 py-4 pr-4 flex md:flex-row flex-col items-center justify-between gap-3 border-b">
        <div class="flex items-center md:flex-1">
            <div class="md:flex items-center hidden">
                <template v-if="calculatedMenuMode === 'overlay' || calculatedMenuMode === 'static'">
                    <button type="button" @click="toggleMenuState" class="cursor-pointer w-9 h-9 flex items-center justify-center rounded-md border hover:bg-surface-100 dark:hover:bg-surface-800 transition-all duration-300">
                        <i class="pi pi-bars text-xl" />
                    </button>
                    <Divider layout="vertical" />
                </template>
            </div>
            <div class="font-medium md:text-base text-xl flex items-center gap-2">
                <Tag value="Admin" severity="warn" class="!text-xs !py-0.5 !px-1.5 !font-medium" />
                {{ pageTitle }}
            </div>
        </div>

        <div class="flex items-center md:flex-row flex-col gap-4">
            <!-- Search -->
<!--            <IconField class="">-->
<!--                <InputIcon class="pi pi-search" />-->
<!--               <InputText v-model="search" placeholder="Search" />-->
<!--            </IconField>-->
            <div class="flex items-center gap-4">
                <!-- Currency Selector -->
                <SelectCurrency 
                    :user-currency="page.props.auth.user?.coin || 'USD'"
                    :available-currencies="page.props.currencies"
                    context="admin"
                />
                <!-- Translate Selector -->
                <div class="translateToggle">
                    <SelectLanguage context="admin" />
                </div>
                <button type="button" @click="toggleMenuState" class="md:hidden cursor-pointer w-9 h-9 flex items-center justify-center rounded-md border hover:bg-surface-100 dark:hover:bg-surface-800 transition-all duration-300">
                    <i class="pi pi-bars text-xl" />
                </button>
                <!-- Notifications -->

                <div class="sm:relative">
                    <a v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'animate-scalein', leaveActiveClass: 'animate-fadeout', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                        <Button icon="pi pi-bell" severity="secondary" outlined class="!aspect-square" />
                    </a>
                    <div class="absolute hidden w-1/2 min-w-72 top-auto right-4 z-[999] mt-2">
                        <AdminNotificationsDropdown class="w-full sm:w-[22rem]" />
                    </div>
                </div>
                <!-- Profile -->
                <div class="relative">
                    <a v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'animate-scalein', leaveActiveClass: 'animate-fadeout', leaveToClass: 'hidden', hideOnOutsideClick: true }" class="flex items-center gap-2 cursor-pointer">
                        <span class="text-sm font-medium hidden sm:inline">{{ ((page.props.auth.user?.first_name ?? '') + ' ' + (page.props.auth.user?.last_name ?? '')).trim() || page.props.auth.user.name }}</span>
                        <Button icon="pi pi-user" severity="secondary" outlined class="!aspect-square" />
                    </a>
                    <div class="absolute hidden top-full right-0 z-[999] mt-2">
                        <AdminProfileDropdown class="w-52" />
                    </div>
                </div>

<!--                <Button @click="toggleRightMenu" icon="pi pi-align-right" severity="secondary" outlined class="!aspect-square" />-->
<!--                <RightMenu ref="rightMenuRef" :open="rightMenuOpen" @toggle="(value) => (rightMenuOpen = value)" />-->
            </div>
        </div>
    </header>
</template>
